module.exports = __webpack_public_path__ + "img/des_piano_03.92438f71.jpg";